/*
 * HelloSpicy — Message « livraison offerte » de la fiche produit (audit A8).
 * Rendu initial par snippets/hs-livraison-produit.liquid ; ce script le tient à
 * jour SANS rechargement : ajout au panier (événement Dawn cart-update, ou relecture
 * de /cart.js), changement de variante (variant-change) et de quantité.
 * Aucun montant en dur : le seuil vient de data-seuil (réglage du thème).
 */
(function () {
  'use strict';
  var SEL = '[data-hs-livraison-produit]';

  function euros(cents) {
    var v = Math.max(0, cents) / 100;
    var s = (Math.round(v * 100) % 100 === 0) ? String(Math.round(v)) : v.toFixed(2).replace('.', ',');
    return s + ' €';
  }

  function quantite(root) {
    var form = document.querySelector('form[id^="product-form-"]');
    var id = form ? form.id : null;
    var input = id ? document.querySelector('input[name="quantity"][form="' + id + '"]') : null;
    input = input || document.querySelector('.product-form__quantity input[name="quantity"]');
    var q = input ? parseInt(input.value, 10) : 1;
    return q > 0 ? q : 1;
  }

  function rendre(root, cart) {
    var seuil = parseInt(root.getAttribute('data-seuil'), 10) || 0;
    if (!seuil || !cart) return;
    var pid = parseInt(root.getAttribute('data-product-id'), 10);
    var prix = parseInt(root.getAttribute('data-prix'), 10) || 0;
    var dansPanier = (cart.items || []).some(function (it) { return it.product_id === pid; });
    var total = cart.total_price || 0;
    // Le reste se calcule sur le panier seul : le produit affiché n'est compté
    // que pour annoncer « Avec ce produit… » (voir le snippet Liquid).
    var reste = seuil - total;
    var avecProduit = total + (dansPanier ? 0 : prix * quantite(root));
    var txt = root.querySelector('[data-hs-livraison-texte]');
    if (!txt) return;
    var etat;
    if (total >= seuil) {
      etat = 'offert';
      txt.innerHTML = '<strong>Livraison offerte en point relais</strong>';
    } else if (!dansPanier && avecProduit >= seuil) {
      etat = 'avec-produit';
      txt.innerHTML = 'Avec ce produit, la <strong>livraison en point relais est offerte</strong>';
    } else if (total === 0) {
      etat = 'vide';
      txt.innerHTML = 'Livraison offerte en point relais dès <strong>' + euros(seuil) + '</strong>';
    } else {
      etat = 'reste';
      txt.innerHTML = 'Plus que <strong>' + euros(reste) + '</strong> pour la livraison offerte en point relais';
    }
    root.setAttribute('data-etat', etat);
  }

  var dernierPanier = null;
  function lirePanier() {
    var url = (window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js';
    return fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) { if (c) { dernierPanier = c; toutRendre(); } return c; })
      .catch(function () { /* on garde l'état rendu par Liquid */ });
  }
  function toutRendre() {
    if (!dernierPanier) return;
    document.querySelectorAll(SEL).forEach(function (r) { rendre(r, dernierPanier); });
  }

  function init() {
    if (!document.querySelector(SEL)) return;
    lirePanier();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { lirePanier(); });
      subscribe(PUB_SUB_EVENTS.variantChange, function (e) {
        var v = e && e.data && e.data.variant;
        if (v && typeof v.price === 'number') {
          document.querySelectorAll(SEL).forEach(function (r) { r.setAttribute('data-prix', v.price); });
        }
        toutRendre();
      });
    }
    document.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'quantity') toutRendre();
    });
    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('quantity-input button')) setTimeout(toutRendre, 0);
    });
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') lirePanier();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
